import { ReactSelect, ReactSelectProps } from "@/components/Selects/ReactSelect";

type Props = ReactSelectProps;

export function DischargeTypeSelect({ ...rest }: Props) {
	const dischargeTypeOptions = [
		{ value: "1", label: "ALTA MELHORADA" },
		{ value: "2", label: "ALTA CURADA" },
		{ value: "3", label: "ALTA A PEDIDO" },
		{ value: "5", label: "ALTA POR ÓBITO" },
		{ value: "7", label: "ALTA POR TRANSFERÊNCIA" },
		{ value: "8", label: "ALTA POR INDICAÇÃO MÉDICA" },
	];

	return <ReactSelect isSolid options={dischargeTypeOptions} {...rest} />;
}
